import { FieldTypes } from 'drapcode-constant';
import { findParentCollection } from '../collectionTraits/utils';
import { fieldTraitTextContentOptions } from '../dataGroup/traitsApi';
import { getCollectionFields, getInstalledPlugins } from '../pluginComponentApi';
import { stripeConnectType } from './consts';

export default async function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { pfx, classPfx, projectId, collections, version } = opts;

  const installedPlugins = projectId ? await getInstalledPlugins(projectId, version) : '';
  const multiTenantPlugin =
    installedPlugins && installedPlugins.find((plugin) => plugin.code === 'MULTI_TENANT_SAAS');
  const { setting: multiTenantSetting } = multiTenantPlugin || '';
  const { multiTenantCollection } = multiTenantSetting || '';

  domc.addType(stripeConnectType, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-cart-check"></i>',
          droppable: ':not(form)',
          draggable: ':not(form)',
          collectionName: '',
          projectId: projectId,
          resizable: true,
          traits: [
            ...defaultModel.prototype.defaults.traits,
            {
              type: 'content',
              label: 'Text',
            },
            {
              type: 'checkbox',
              label: 'Open in new tab',
              name: 'data-newtab',
            },
          ],
        },
        async init() {
          const collectionName = findParentCollection(this, opts);
          if (collectionName) {
            const collectionResponse = await getCollectionFields(collectionName, collections);
            const userCollectionResponse = await getCollectionFields('user', collections);
            const dataItemCustomerFrom = this.get('data-item-customer-from');
            if (!dataItemCustomerFrom) {
              this.set('data-item-customer-from', '');
            }
            const options = [
              { value: '', name: '- Select One -' },
              { value: 'CURRENT_USER_FIELD', name: 'Current Logged In User' },
            ];
            // if (multiTenantCollection) {
            //   const multiTenantCollectionObj = collections.find(
            //     (collection) => collection.uuid === multiTenantCollection,
            //   );
            //   const multiTenantCollectionName = multiTenantCollectionObj
            //     ? multiTenantCollectionObj.collectionTitle
            //     : 'Tenant';
            //   options.push({
            //     value: 'CURRENT_TENANT_FIELD',
            //     name: `Current Logged In ${multiTenantCollectionName}`,
            //   });
            // }
            // options.push({ value: 'BROWSER_SESSION_STORAGE', name: 'Browser Session Storage' });

            if (collectionResponse || userCollectionResponse) {
              const textTraitsOptions = await fieldTraitTextContentOptions(
                collectionResponse,
                collections,
              );
              const userTextTraitsOptions = await fieldTraitTextContentOptions(
                userCollectionResponse,
                collections,
              );
              if (textTraitsOptions) {
                this.addTrait({
                  label: 'Name Field',
                  name: 'data-item-name',
                  title: 'name',
                  type: 'data-stripe-trait',
                  options: textTraitsOptions,
                });
                this.addTrait({
                  label: 'Description Field',
                  name: 'data-item-description',
                  title: 'description',
                  type: 'data-stripe-trait',
                  options: textTraitsOptions,
                });
                this.addTrait({
                  label: 'Price Field',
                  name: 'data-item-price',
                  title: 'price',
                  type: 'data-stripe-trait',
                  options: textTraitsOptions,
                });
                this.addTrait(
                  {
                    type: 'select',
                    label: 'Get Customer From',
                    name: 'data-item-customer-from',
                    title: 'customer-from',
                    options: [...options],
                    value: dataItemCustomerFrom,
                    changeProp: 1,
                  },
                  { at: this.getTraitIndex('data-item-price') + 1 },
                );
                if (dataItemCustomerFrom) {
                  const dataItemCustomerTrait = this.getTrait('data-item-customer-field');
                  if (!dataItemCustomerTrait) {
                    this.addTrait({
                      label: `Customer Field`,
                      name: 'data-item-customer-field',
                      title: 'customer',
                      type: 'data-stripe-trait',
                      options: userTextTraitsOptions,
                    });
                  }
                }
              }

              const collectionReferenceFields =
                collectionResponse.fields && collectionResponse.fields.length > 0
                  ? collectionResponse.fields.filter((crd) => crd.type === FieldTypes.reference.id)
                  : [];
              this.setAttributes({
                selectedCollectionData: JSON.stringify(collectionReferenceFields),
                onclick: 'stripeConnectCheckout(event)',
              });
            }
          }
          this.on('change:data-item-customer-from', this.handleCustomerFromChange);
        },
        async handleCustomerFromChange() {
          const dataItemCustomerFrom = this.get('data-item-customer-from');
          const attrs = this.getAttributes();
          attrs['data-item-customer-from'] = dataItemCustomerFrom;
          this.addAttributes(attrs);

          if (dataItemCustomerFrom) {
            const dataItemCustomerTrait = this.getTrait('data-item-customer-field');
            if (dataItemCustomerTrait) {
              this.removeTrait('data-item-customer-field');
            }
            switch (dataItemCustomerFrom) {
              case 'CURRENT_USER_FIELD':
                const userCollectionResponse = await getCollectionFields('user', collections);
                if (userCollectionResponse) {
                  const userTextTraitsOptions = await fieldTraitTextContentOptions(
                    userCollectionResponse,
                    collections,
                  );
                  if (userTextTraitsOptions) {
                    this.addTrait({
                      label: `Customer Field`,
                      name: 'data-item-customer-field',
                      title: 'customer',
                      type: 'data-stripe-trait',
                      options: userTextTraitsOptions,
                    });
                  }
                }
                break;
              case 'CURRENT_TENANT_FIELD':
                break;
              case 'BROWSER_SESSION_STORAGE':
                break;
              default:
                break;
            }
          } else {
            const dataItemCustomerTrait = this.getTrait('data-item-customer-field');
            if (dataItemCustomerTrait) {
              let attrs = this.getAttributes();
              delete attrs['data-item-customer-from'];
              delete attrs['data-item-customer-field'];
              this.addAttributes(attrs);
              this.removeTrait('data-item-customer-field');
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === stripeConnectType) {
            return {
              type: stripeConnectType,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(this.model, 'change:content', this.updateContent);
        this.listenTo(model, 'change:data-item-name', this.updateScript);
        this.listenTo(model, 'change:data-item-description', this.updateScript);
        this.listenTo(model, 'change:data-item-price', this.updateScript);
        this.listenTo(model, 'change:data-item-customer', this.updateScript);
      },
      updateContent() {
        if (this.model.get('content')) {
          this.el.innerHTML = this.model.get('content');
        }
      },
    }),
  });
}
